class GalleryComponent extends HTMLElement {
  constructor() {
    super();

    if (window.Glider) {
      this.initGlider();
      this.initThumbnailListeners();
    }
  }

  get gliderOptions() {
    return {
      slidesToShow: 1,
      draggable: true,
      dragVelocity: 2,
      scrollLock: true,
      dots: '#gallery-dots',
      rewind: true
    }
  }

  initGlider() {
    this.gallery  = new Glider(
      this.firstElementChild,
      this.gliderOptions
    );
  }

  initThumbnailListeners() {
    const galleryTray = this.querySelector('.gallery__tray');
    if (galleryTray && galleryTray.children.length) {
      let thumbs = Array.from(galleryTray.children);
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', this.gotoSlide.bind(this))
      });
    }
  }

  gotoSlide(event) {
    let slideIndex = event.currentTarget.dataset.index;
    this.gallery.scrollItem(slideIndex, true);
  }
}

window.customElements.define('gallery-component', GalleryComponent);
